import Layout from '@/layout'

const RobotRouter = {
  path: '/RpaRobot',
  component: Layout,
  redirect: 'noredirect',
  name: 'RpaRobot',
  meta: {
    title: 'RpaRobot',
    icon: 'daohang-ziliaoguanli',
    roles: []
  },
  children: [
    {
      path: 'operationRobot',
      component: () => import('@/views/cargo/v0/RpaRobot/operationRobot'),
      name: 'operationRobot',
      meta: { title: '机器人运行' },
      roles: ['module_OperationRobot']
    },
    {
      path: 'programManagement',
      component: () => import('@/views/cargo/v0/RpaRobot/programManagement'),
      name: 'programManagement',
      meta: { title: '计划查询' },
      roles: ['module_Program']
    },
    {
      path: 'runningQuery',
      component: () => import('@/views/cargo/v0/RpaRobot/runningQuery'),
      name: 'runningQuery',
      meta: { title: '运行查询' },
      roles: ['module_Running']
    }
  ]
}

export default RobotRouter
